// extracted by mini-css-extract-plugin
export default {"page":"SellerGuide_page__PBzN4","container":"SellerGuide_container__gofc+"};